export const lineStyle = {
  root: {
    height: 1,
    backgroundColor: "#464866",
  },
};
